import type { RouteRecordRaw } from 'vue-router'

export const workerRoutes: RouteRecordRaw[] = [
    {
        path: '/workers',
        name: 'Workers',
        component: () => import('@/views/workers/WorkersView.vue'),
        meta: { requiresAuth: true, allowedRoles: ['ADMIN', 'SUPERVISOR'] },
    },
    {
        path: '/workers/:id',
        name: 'WorkerDetail',
        component: () => import('@/views/workers/WorkerDetail.vue'),
        meta: { requiresAuth: true, allowedRoles: ['ADMIN', 'SUPERVISOR'] },
    },
]
